import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

export default function AddRoutine() {
    const [routineName, setRoutineName] = useState("")
    const [goal, setGoal] = useState("")
    const [isPublic, setIsPublic] = useState(true)
    const navigate = useNavigate()

    const handleSubmit = async (event) => {
        event.preventDefault();
        const token = localStorage.getItem("token");
        try {
            const response = await fetch(
                "https://fitnesstrac-kr.herokuapp.com/api/routines/",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        name: routineName,
                        goal: goal
                    }),
                }
            );
            const result = await response.json();
            console.log(result)
            navigate("/Profile");
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div className="form-container" >
            <form onSubmit={handleSubmit}>
                <h1>Add a Routine</h1>
                <div>
                    <label htmlFor="routineName"></label>
                    <input
                        type="text"
                        id="routineName"
                        placeholder="Routine Name"
                        value={routineName}
                        onChange={(e) => setRoutineName(e.target.value)}
                    />
                </div>
                <div>
                    <label htmlFor="goal"></label>
                    <input
                        type="text"
                        id="goal"
                        placeholder="Routine Goal"
                        value={goal}
                        onChange={(e) => setGoal(e.target.value)}
                    />
                </div> 
                <div>
                    <label htmlFor="isPublic">Make Public?</label>
                    <input
                        type="checkbox"
                        id="isPublic"
                        value={isPublic}
                        onChange={(e) => setIsPublic(e.target.value)}
                    />
                </div>
                <button className="submit-btn" type="submit">Create Routine</button>
            </form>
        </div>
    );
}
 